module.exports = __webpack_public_path__ + "media/images/icons/icons_small/62_twoBaloons-2551532083b87b79083624c70e1c4dea.png";